export const STORAGE_KEYS = {
  favBoard: 'fav-returns-board',
};
